import { render, staticRenderFns } from "./DiscussionHeader.vue?vue&type=template&id=40571248&scoped=true&"
import script from "./DiscussionHeader.vue?vue&type=script&lang=js&"
export * from "./DiscussionHeader.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionHeader.vue?vue&type=style&index=0&id=40571248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40571248",
  null
  
)

export default component.exports